import { render, staticRenderFns } from "./CustomDeclaration.vue?vue&type=template&id=a9e25614&scoped=true"
import script from "./CustomDeclaration.vue?vue&type=script&lang=ts"
export * from "./CustomDeclaration.vue?vue&type=script&lang=ts"
import style0 from "./CustomDeclaration.vue?vue&type=style&index=0&id=a9e25614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e25614",
  null
  
)

export default component.exports